function checkNavigator(testExp: RegExp): boolean {
  // Depending on the execution environment, navigator might either be undefined or throw a ReferenceError.
  try {
    return testExp.test(navigator.userAgent);
  } catch {
    return false;
  }
}

export const isEdge = checkNavigator(/Edge\//);
export const isMac = checkNavigator(/Mac/);

/**
 * Platform-aware version of `e.ctrlKey`
 */
export function isCtrl(event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement> | React.TouchEvent<HTMLElement>): boolean {
  if (isMac) {
    return event.metaKey || event.ctrlKey;
  } else {
    return event.ctrlKey;
  }
}
